<section class="u-table" aria-label="User table">
  <div class="u-table__wrap" [class.is-loading]="loading">
    <table class="u-table__table">
      <thead>
        <tr>
          <th class="col-no">#</th>
          <th>
            {{ "view_value.first_name" | translate }}
          </th>
          <th>{{ "view_value.last_name" | translate }}</th>
          <th>{{ "view_value.email" | translate }}</th>
          <th>{{ "view_value.phone" | translate }}</th>
          <th>{{ "view_value.created_date" | translate }}</th>
          <th>{{ "view_value.access_permissions" | translate }}</th>
          <th class="col-status">{{ "view_value.status" | translate }}</th>
          <th class="col-actions">{{ "view_value.actions" | translate }}</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngIf="!loading && rows.length === 0">
          <td class="empty" colspan="9">
            {{ "view_value.no_data" | translate }}
          </td>
        </tr>

        <tr *ngFor="let u of rows; let i = index; trackBy: trackById">
          <td class="col-no">{{ i + 1 }}</td>
          <td class="accent">{{ u.first_name || "-" }}</td>
          <td class="accent">{{ u.last_name || "-" }}</td>
          <td class="accent">{{ u.email || "-" }}</td>
          <td class="accent">{{ u.tel_no || "-" }}</td>
          <td class="accent">
            {{
              u.create_at ? (u.create_at | date: "dd/MM/yyyy HH:mm:ss") : "-"
            }}
          </td>
          <td class="accent">{{ u.role || "-" }}</td>

          <td class="col-status">
            <ng-container *ngIf="isActive(u) as active">
              <span
                class="status"
                [class.status--active]="active"
                [class.status--inactive]="!active"
                [attr.aria-label]="active ? 'active' : 'inactive'"
                role="img"
              >
                {{ statusLabel(active) | translate }}
              </span>
            </ng-container>
          </td>

          <td class="col-actions">
            <button
              type="button"
              class="icon-btn icon-btn--edit"
              (click)="onEdit(u)"
              aria-label="แก้ไขผู้ใช้"
              title="แก้ไข"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.8067 11.1397L12.1933 9.52634C12.1314 9.46385 12.0576 9.41426 11.9764 9.38041C11.8951 9.34657 11.808 9.32914 11.72 9.32914C11.632 9.32914 11.5449 9.34657 11.4636 9.38041C11.3824 9.41426 11.3086 9.46385 11.2467 9.52634L8.86 11.913C8.79821 11.9753 8.74933 12.0492 8.71615 12.1304C8.68298 12.2116 8.66616 12.2986 8.66667 12.3863V13.9997C8.66667 14.1765 8.7369 14.3461 8.86193 14.4711C8.98695 14.5961 9.15652 14.6663 9.33333 14.6663H10.9467C11.0344 14.6668 11.1214 14.65 11.2026 14.6169C11.2838 14.5837 11.3577 14.5348 11.42 14.473L13.8067 12.0863C13.8692 12.0244 13.9187 11.9506 13.9526 11.8694C13.9864 11.7882 14.0039 11.701 14.0039 11.613C14.0039 11.525 13.9864 11.4379 13.9526 11.3566C13.9187 11.2754 13.8692 11.2016 13.8067 11.1397ZM10.6667 13.333H10V12.6663L11.72 10.9463L12.3867 11.613L10.6667 13.333ZM6.66667 13.333H4C3.82319 13.333 3.65362 13.2628 3.5286 13.1377C3.40357 13.0127 3.33333 12.8432 3.33333 12.6663V3.33301C3.33333 3.1562 3.40357 2.98663 3.5286 2.8616C3.65362 2.73658 3.82319 2.66634 4 2.66634H7.33333V4.66634C7.33333 5.19677 7.54405 5.70548 7.91912 6.08055C8.29419 6.45563 8.8029 6.66634 9.33333 6.66634H11.3333V7.33301C11.3333 7.50982 11.4036 7.67939 11.5286 7.80441C11.6536 7.92944 11.8232 7.99967 12 7.99967C12.1768 7.99967 12.3464 7.92944 12.4714 7.80441C12.5964 7.67939 12.6667 7.50982 12.6667 7.33301V5.99967C12.6667 5.99967 12.6667 5.99967 12.6667 5.95967C12.6597 5.89843 12.6463 5.83809 12.6267 5.77967V5.71967C12.5946 5.65113 12.5519 5.58812 12.5 5.53301L8.5 1.53301C8.44489 1.48115 8.38188 1.4384 8.31333 1.40634C8.29343 1.40351 8.27323 1.40351 8.25333 1.40634L8.04 1.33301H4C3.46957 1.33301 2.96086 1.54372 2.58579 1.91879C2.21071 2.29387 2 2.80257 2 3.33301V12.6663C2 13.1968 2.21071 13.7055 2.58579 14.0806C2.96086 14.4556 3.46957 14.6663 4 14.6663H6.66667C6.84348 14.6663 7.01305 14.5961 7.13807 14.4711C7.26309 14.3461 7.33333 14.1765 7.33333 13.9997C7.33333 13.8229 7.26309 13.6533 7.13807 13.5283C7.01305 13.4032 6.84348 13.333 6.66667 13.333ZM8.66667 3.60634L10.3933 5.33301H9.33333C9.15652 5.33301 8.98695 5.26277 8.86193 5.13775C8.7369 5.01272 8.66667 4.84315 8.66667 4.66634V3.60634ZM5.33333 9.33301H9.33333C9.51014 9.33301 9.67971 9.26277 9.80474 9.13774C9.92976 9.01272 10 8.84315 10 8.66634C10 8.48953 9.92976 8.31996 9.80474 8.19494C9.67971 8.06991 9.51014 7.99967 9.33333 7.99967H5.33333C5.15652 7.99967 4.98695 8.06991 4.86193 8.19494C4.7369 8.31996 4.66667 8.48953 4.66667 8.66634C4.66667 8.84315 4.7369 9.01272 4.86193 9.13774C4.98695 9.26277 5.15652 9.33301 5.33333 9.33301ZM5.33333 6.66634H6C6.17681 6.66634 6.34638 6.5961 6.4714 6.47108C6.59643 6.34605 6.66667 6.17649 6.66667 5.99967C6.66667 5.82286 6.59643 5.65329 6.4714 5.52827C6.34638 5.40325 6.17681 5.33301 6 5.33301H5.33333C5.15652 5.33301 4.98695 5.40325 4.86193 5.52827C4.7369 5.65329 4.66667 5.82286 4.66667 5.99967C4.66667 6.17649 4.7369 6.34605 4.86193 6.47108C4.98695 6.5961 5.15652 6.66634 5.33333 6.66634ZM6.66667 10.6663H5.33333C5.15652 10.6663 4.98695 10.7366 4.86193 10.8616C4.7369 10.9866 4.66667 11.1562 4.66667 11.333C4.66667 11.5098 4.7369 11.6794 4.86193 11.8044C4.98695 11.9294 5.15652 11.9997 5.33333 11.9997H6.66667C6.84348 11.9997 7.01305 11.9294 7.13807 11.8044C7.26309 11.6794 7.33333 11.5098 7.33333 11.333C7.33333 11.1562 7.26309 10.9866 7.13807 10.8616C7.01305 10.7366 6.84348 10.6663 6.66667 10.6663Z"
                  fill="white"
                />
              </svg>
            </button>

            <button
              type="button"
              class="icon-btn icon-btn--danger"
              (click)="onDelete(u)"
              aria-label="ลบผู้ใช้"
              title="ลบ"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M0.5 2.5C0.5 1.94772 0.947715 1.5 1.5 1.5H14.5C15.0523 1.5 15.5 1.94772 15.5 2.5V4C15.5 4.55228 15.0523 5 14.5 5H13.9507L13.1014 13.1686C13.1011 13.1708 13.1009 13.1731 13.1006 13.1753C13.0577 13.5403 12.8823 13.8767 12.6077 14.1209C12.3331 14.3651 11.9784 14.5 11.6109 14.5H4.38936C4.0219 14.5 3.66723 14.3651 3.39263 14.1209C3.11804 13.8767 2.94262 13.5403 2.89968 13.1753C2.89941 13.1731 2.89917 13.1708 2.89893 13.1686L2.04931 5H1.5C0.947715 5 0.5 4.55228 0.5 4V2.5ZM2.50692 4C2.50272 3.99995 2.49851 3.99995 2.49429 4H1.5V2.5H14.5V4H13.5057C13.5015 3.99995 13.4973 3.99995 13.4931 4H2.50692ZM3.0547 5L3.89316 13.0612C3.90803 13.1818 3.96631 13.2929 4.05714 13.3736C4.14867 13.455 4.2669 13.5 4.38939 13.5H11.6109C11.7334 13.5 11.8516 13.455 11.9432 13.3736C12.034 13.2929 12.0923 13.1818 12.1072 13.0612L12.9453 5H3.0547ZM5.89645 7.14645C6.09171 6.95118 6.40829 6.95118 6.60355 7.14645L8 8.54289L9.39645 7.14645C9.59171 6.95118 9.90829 6.95118 10.1036 7.14645C10.2988 7.34171 10.2988 7.65829 10.1036 7.85355L8.70711 9.25L10.1036 10.6464C10.2988 10.8417 10.2988 11.1583 10.1036 11.3536C9.90829 11.5488 9.59171 11.5488 9.39645 11.3536L8 9.95711L6.60355 11.3536C6.40829 11.5488 6.09171 11.5488 5.89645 11.3536C5.70118 11.1583 5.70118 10.8417 5.89645 10.6464L7.29289 9.25L5.89645 7.85355C5.70118 7.65829 5.70118 7.34171 5.89645 7.14645Z"
                  fill="#FF4344"
                />
              </svg>
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="u-table__overlay" *ngIf="loading" aria-hidden="true">
      <div class="spinner"></div>
    </div>
  </div>
</section>
